import axios from 'axios';

// The configured API URL already includes /api/v1. Never attach the saved login
// session to these public endpoints; the request ID and OTP identify the account.
const client = axios.create({
  baseURL: process.env.REACT_APP_API_BASE_URL,
  timeout: 20000,
  headers: { 'Content-Type': 'application/json' },
});

function payload(response) {
  const body = response.data;
  // These are application codes, not HTTP status codes (900 means success).
  if (body?.status !== 'SUCCESS' || body?.code !== 900) {
    throw new Error('The server did not confirm this request. Please try again or contact support.');
  }
  return body;
}

export async function requestAccountDeletion(identifier) {
  const mobile = typeof identifier.mobile_number === 'string' && identifier.mobile_number.trim();
  const email = typeof identifier.email === 'string' && identifier.email.trim();
  if (Boolean(mobile) === Boolean(email)) {
    throw new Error('Provide exactly one registered phone number or email.');
  }
  const body = mobile
    ? { mobile_number: mobile, ...(identifier.country_code ? { country_code: identifier.country_code } : {}) }
    : { email };
  const result = payload(await client.post('/account-deletion/request', body));
  const requestId = result.data?.request_id;
  if (typeof requestId !== 'string' || !requestId.trim()) {
    throw new Error('The server did not return a verification request. Please try again.');
  }
  return requestId;
}

export async function confirmAccountDeletion(requestId, otp) {
  if (typeof requestId !== 'string' || !requestId.trim() || !/^[0-9]{6}$/.test(otp)) {
    throw new Error('A verification request and 6-digit code are required.');
  }
  payload(await client.post('/account-deletion/confirm', { request_id: requestId, otp }));
}
